export const cancelReasons = [
  "Unable to gain entry",
  "Service away from home",
  "Client refused visits",
  "Forgot to log in or out",
  "Office Notified",
  "No reply",
  "Planned absence",
  "Cancellation - Informal Carer without correct notice",
  "Cancellation - With correct notice",
  "Cancellation - Without correct notice",
  "Delivered",
  "Door-stop Refusal",
  "Emergency Hospital Admission",
  "Missed Visit - No Service Provided",
  "Reablement",
  "Respite",
  "Scheduled Hospital Admission",
  "Unplanned / Emergency Care",
];
